// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_mlsPlan(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ListOnMlsAsActive",
    "ListOnMlsAsComingSoon",
    "NoMlsPlan"
  ]);
}

let fragmentConverter = {"__root":{"website":{"b":""},"showings_startDate":{"b":""},"mlsPlan_ListOnMlsAsComingSoon_activeOnMlsOn":{"b":""},"mlsPlan_ListOnMlsAsActive_onMlsAt":{"b":""},"mlsPlan":{"u":"fragment_mlsPlan"}}};

let fragmentConverterMap = {
  fragment_mlsPlan: unwrap_fragment_mlsPlan
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShowPriorToMls",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffersPriorToMls",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayPreviewListingDetails_previewHelpers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShowingV5",
      "kind": "LinkedField",
      "name": "showings",
      "plural": true,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CondoProperty",
      "kind": "LinkedField",
      "name": "condoProperty",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parkingSpaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parkingDetails",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "mlsPlan",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onMlsAt",
                "storageKey": null
              },
              "action": "THROW"
            },
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "type": "ListOnMlsAsActive",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeOnMlsOn",
                "storageKey": null
              },
              "action": "THROW"
            },
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "type": "ListOnMlsAsComingSoon",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willShow",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willAcceptOffers",
              "storageKey": null
            }
          ],
          "type": "NoMlsPlan",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    }
  ],
  "type": "PropertyPreviewHelpers",
  "abstractKey": null
};
})());

let wrap_fragment_mlsPlan = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_mlsPlan = unwrap_fragment_mlsPlan;
exports.wrap_fragment_mlsPlan = wrap_fragment_mlsPlan;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
